<script>
import ListView from "@/arch/components/data-table/ListView.vue";
import { mapActions, mapGetters } from "vuex";
import DataTableLinkText from "@/arch/components/data-table/columns/DataTableLinkText";
import DataTableChipStatus from "../items/components/DataTableChipStatus.vue";
import { VUE_APP_DECIMALS, VUE_APP_API_URL } from "@/config";
import utils from "@/utils";
import axios from "axios";

export default {
  extends: ListView,
  name: "ViewListItems",
  data() {
    return {
      namePage: this.$i18n.t("pendingItems"),
      path: "items",
      filterContent: () => import("./components/ItemsFiltersComponent.vue"),
      headerContent: () => import("./components/ItemsHeaderComponent.vue"),
      hideDefaultActions: true,
      addNew: false,
      pagination: {
        sortBy: "ORDER_DATE",
        sortDesc: true,
      },
      dataProperties: { path: "items", namePage: this.$i18n.t("pendingItems") },
      headers: [
        {
          text: this.$i18n.t("orderNumber"),
          align: "start",
          sortable: true,
          value: "SALES_ORDER",
          component: DataTableLinkText,
          options: {
            to: { name: "OrderDetails" },
            field: "SALES_ORDER",
            transform: (value) => value,
          },
        },
        {
          text: this.$i18n.t("purchaseOrder"),
          align: "start",
          sortable: true,
          value: "CUSTOMER_PO",
        },
        {
          text: this.$i18n.t("createdDate"),
          align: "start",
          sortable: true,
          value: "ORDER_DATE",
          component: "DataTableDateOnlyColumn",
        },
        {
          text: this.$i18n.t("requestDate"),
          align: "start",
          sortable: true,
          value: "LINE_REQUEST_DATE",
          component: "DataTableDateOnlyColumn",
        },
        {
          text: this.$i18n.t("productCode"),
          align: "start",
          sortable: true,
          value: "ITEM",
        },
        {
          text: this.$i18n.t("product"),
          align: "start",
          sortable: true,
          value: "DESCRIPTION",
        },
        {
          text: this.$i18n.t("requestedAmount"),
          align: "start",
          sortable: true,
          value: "ORDERED_QUANTITY",
        },
        {
          text: this.$i18n.t("pendingAmount"),
          align: "start",
          sortable: true,
          value: "PENDING_QTY",
        },
        {
          text: this.$i18n.t("pendingValue"),
          align: "start",
          sortable: true,
          value: "PRICE",
          component: "DataTableCurrencyColumn",
          infoMessage: this.$i18n.t("valueWithoutTaxes"),
          options: {
            prefix: "$USD",
            dynamicPrefix: "CURRENCY", //TODO: diferente do Order_all, não existe o campo no objeto
            decimals: VUE_APP_DECIMALS,
          },
        },
        {
          text: this.$i18n.t("status"),
          align: "start",
          sortable: true,
          value: "RELEASED_STATUS",
          component: DataTableChipStatus,
        },
      ],
      thisPage: "itens_pendentes",
    };
  },
  computed: {
    ...mapGetters("itemsStore", {
      getGoodList: "getList",
    }),
  },
  created() {
    this.saveAccessPage();
  },
  methods: {
    ...mapActions({
      setDataToList(dispatch, payload) {
        return dispatch(this.getPathStore + "/setDataToList", {
          ...payload,
          where: "regexp_like (tvtp.TYPE, '^V(E|X)')",
          list_type: "full",
          sortBy: this.pagination.sortBy,
          sortByAsc: !this.pagination.sortDesc,
        });
      },
    }),
    ...mapActions("itemsStore", ["setDefaultPath"]),
    async saveAccessPage() {
      let country = utils.loadCountry();
      let userid = utils.loadUserId();

      axios.post(`${VUE_APP_API_URL}venusa/saveAccessPage`, {
        UNIDADE_PAIS: country,
        USERID: userid,
        THISPAGE: this.thisPage,
        TOKEN: utils.loadToken(),
      });
    },
  },
};
</script>
